import { getStore } from '../store/store';
import AddCalendarsDeeplinkState from '../store/schema/AddCalendarsDeeplinkState';
import AddCalendarsMenuItemId from '../store/schema/AddCalendarsMenuItemId';

export default function getAddCalendarState(): AddCalendarsDeeplinkState {
    const store = getStore();
    return {
        addCalendarPanelVisible: store.showAddCalendarsPanel,
        teamSnapPanelVisible:
            store.selectedAddCalendarsMenuItemId === AddCalendarsMenuItemId.TeamSnap,
        schoolsPaneVisible: store.selectedAddCalendarsMenuItemId === AddCalendarsMenuItemId.Schools,
        personalAccountPaneVisible:
            store.selectedAddCalendarsMenuItemId === AddCalendarsMenuItemId.Personal,
    };
}
